export interface ClamEnv {
    COGNITO_REGION: string;
    COGNITO_USER_POOL_ID: string;
    COGNITO_APP_CLIENT_ID: string;
    MORPHED_API_URL: string;
    MORPHED_PROXY_TARGET: string;
    MORPHED_API_KEY: string;
    CLAM_BACKEND_URL: string;
    MORPHED_ORG: string;
}

export const env: ClamEnv = {
    COGNITO_REGION: import.meta.env.VITE_COGNITO_REGION || 'us-west-1',
    COGNITO_USER_POOL_ID: import.meta.env.VITE_COGNITO_USER_POOL_ID || 'us-west-1_rt7BRDIVJ',
    COGNITO_APP_CLIENT_ID: import.meta.env.VITE_COGNITO_APP_CLIENT_ID || '6441kiusm5uleggvc3a1d5is0b',
    MORPHED_API_URL: import.meta.env.VITE_MORPHED_API_URL || '/api',
    MORPHED_PROXY_TARGET: import.meta.env.VITE_MORPHED_PROXY_TARGET || '',
    MORPHED_API_KEY: import.meta.env.VITE_MORPHED_API_KEY || '',
    CLAM_BACKEND_URL: import.meta.env.VITE_CLAM_BACKEND_URL || '',
    MORPHED_ORG: import.meta.env.VITE_MORPHED_ORG || 'clam',
};
